import * as yup from "yup";

export const myAccountSchema = yup.object({
	firstName: yup.string().trim().required("First Name is required"),
	lastName: yup.string().trim().required("Last Name is required"),
	email: yup.string().trim().email("Email not valid").required("Email is required")
});
